import { UnknownError, PartialUpdateError, TimeoutError, NotFoundError, PermissionDeniedError, AuthenticationError } from './chunk-DGS6LEDH.mjs';
import { FirebaseError } from 'firebase/app';

var mapFunctionsError = (error, message) => {
  var _a, _b;
  switch (error.code) {
    // Authentication errors
    case "functions/unauthenticated":
      return new AuthenticationError(message, { cause: error });
    // Permission errors
    case "functions/permission-denied":
      return new PermissionDeniedError(message, { cause: error });
    // Not found errors
    case "functions/not-found":
      return new NotFoundError(message, { cause: error });
    // Timeout errors
    case "functions/deadline-exceeded":
      return new TimeoutError(message, { cause: error });
    // Internal errors may contain partial update information
    case "functions/internal": {
      const details = error.details;
      if ((details == null ? void 0 : details.partialUpdate) === true) {
        const errorMessage = error.message !== "" ? error.message : message != null ? message : "Partial update occurred";
        return new PartialUpdateError((_a = details.authUpdated) != null ? _a : false, (_b = details.firestoreUpdated) != null ? _b : false, errorMessage, { cause: error });
      }
      return new UnknownError(message, { cause: error });
    }
    // All other error codes map to UnknownError
    case "functions/cancelled":
    case "functions/unknown":
    case "functions/invalid-argument":
    case "functions/already-exists":
    case "functions/resource-exhausted":
    case "functions/failed-precondition":
    case "functions/aborted":
    case "functions/out-of-range":
    case "functions/unimplemented":
    case "functions/unavailable":
    case "functions/data-loss":
    default:
      return new UnknownError(message, { cause: error });
  }
};
var errorProxy = (message) => (e) => {
  if (e instanceof FirebaseError && "code" in e && typeof e.code === "string") {
    return mapFunctionsError(e, message);
  }
  if (e instanceof Error) {
    return new UnknownError(message, { cause: e });
  }
  return new UnknownError(message);
};

export { errorProxy };
//# sourceMappingURL=chunk-F4TFYERD.mjs.map
//# sourceMappingURL=chunk-F4TFYERD.mjs.map